document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.toggleAttribute('data-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filters = document.querySelector('[data-collection-filters]');
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', () => {
      const open = filters.toggleAttribute('data-open');
      filterToggle.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
      const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.step));
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });
});
